import Vue from 'vue';
import scrollService from '@/core/scroll/scroll.service';
import { DirectiveBinding } from 'vue/types/options';
import { getBinding, setBinding, deleteBinding } from './eventBindings';

type ScrollToData = {
	target: string;
	offset: number;
};

function scrollTo(e: Event) {
    const data = getBinding(e.currentTarget as HTMLElement);
    if (!data || !data.value) {
        scrollService.scrollToTop();
        return;
    }

    const value = data.value as ScrollToData;
    const element = document.getElementById(value.target);
    if (!element) {
        scrollService.scrollToTop();
        return;
    }

    scrollService.scrollToElement(element, value.offset);
}

const scrollToDirective = {
    bind: (el: HTMLElement, bindings: DirectiveBinding) => {
        setBinding(el, bindings);
        el.addEventListener('click', scrollTo, false);
    },
    unbind: (el: HTMLElement) => {
        el.removeEventListener('click', scrollTo, false);
        deleteBinding(el);
    }
};

Vue.directive('scrollTo', scrollToDirective);
